import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCommercialNoAccountList } from '../sellThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'commercialNoAccountList';

export const commercialNoAccountListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCommercialNoAccountList });
    },
});

export const commercialNoAccountList = commercialNoAccountListSlice.reducer;
